/**
 * Polyfill for element.matches
 * @source: https://raw.githubusercontent.com/jonathantneal/closest/master/element-closest.js
 */

(function(ElementProto: any) {
    if (typeof ElementProto.matches !== 'function') {
        ElementProto.matches =
            ElementProto.msMatchesSelector ||
            ElementProto.mozMatchesSelector ||
            ElementProto.webkitMatchesSelector ||
            function matches(selector: any) {
                const elements = (this.document || this.ownerDocument).querySelectorAll(selector);
                let index = 0;

                while (elements[index] && elements[index] !== this) {
                    ++index;
                }

                return Boolean(elements[index]);
            };
    }
})(window.Element.prototype);
